(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/javascripts/utils/definitions.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/javascripts/utils/definitions.js'); "use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

(function () {
  'use strict';

  svs = svs || {};
  svs.modules = svs.modules || {};
  svs.modules.player_login = svs.modules.player_login || {};
  svs.modules.player_login.utils = svs.modules.player_login.utils || {};

  function isStandardMobile(userAgent, trinidad, req) {
    var standardMobile, isMobile, isIOs, isAndroid, logText, userAgentFamily, logger;

    if (req) {
      isMobile = req.capabilities.formFactor === 'mobile';
      isIOs = req.capabilities.os.toLowerCase().indexOf('iphone') > -1;
      isAndroid = req.capabilities.os.toLowerCase().indexOf('android') > -1;
      userAgentFamily = userAgent.parse(req.headers['user-agent']).family;
      logger = trinidad.logger('module:player-login');
    } else {
      isMobile = svs.core.detect.formfactor.mobile();
      isIOs = svs.core.detect.os.iOS();
      isAndroid = svs.core.detect.os.android();
      userAgentFamily = svs.utils.ns.isNamespace('svs.player_login.data.login.useragent_family') ? svs.player_login.data.login.useragent_family : '';
      logger = svs.core.log.getLogger('module:player-login');
    }

    if (isMobile) {
      userAgentFamily = userAgentFamily.toLowerCase();

      if (isIOs) {
        if (userAgentFamily.indexOf('safari') > -1 || userAgentFamily.indexOf('firefox') > -1 || userAgentFamily.indexOf('chrome') > -1) {
          logText = 'Standard mobile iOS';
          standardMobile = true;
        } else {
          logText = 'Mobile iOS - Not Safari, not Firefox or not Chrome';
          standardMobile = false;
        }
      } else if (isAndroid) {
        if (userAgentFamily.indexOf('chrome') > -1 || userAgentFamily.indexOf('firefox') > -1 || userAgentFamily.indexOf('opera') > -1 || userAgentFamily.indexOf('samsung internet') > -1) {
          logText = 'Standard mobile android';
          standardMobile = true;
        } else {
          logText = 'Mobile android - Not Chrome, not Firefox, not Opera or not Samsung internet';
          standardMobile = false;
        }
      } else {
        logText = 'Not standard mobile for iOS or android';
        standardMobile = false;
      }
    } else {
      logText = 'Not mobile at all';
      standardMobile = false;
    }

    if (req) {
      logger.debug(logText, req);
    } else {
      logger.debug(logText);
    }

    return standardMobile;
  }

  if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object') {
    module.exports = {
      isStandardMobile: isStandardMobile.bind(undefined, require('useragent'), require('trinidad-core').core)
    };
  } else {
    svs.modules.player_login.utils.isStandardMobile = isStandardMobile;
  }
})();
 })(window);